<template>
  <div>
    <!-- Inicio Contenido -->
    <SectionTitle
      :has-line="true"
      content="Evaluaciones de Asistencia Tecnológica Año en Curso"
    />

    <div class="container-table-striped mb-5">
      <div class="table-hover">
        <table class="table content-table-striped">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-1" />
              <th class="col-2 bold">
                <span>Evaluación:</span>
              </th>
              <th class="col-3 bold">
                Fecha:
              </th>
              <th class="col-3 bold">
                Administrada por:
              </th>
              <th class="col-3">
                <span class="d-flex text-center" />
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="this.evaluations.length > 0">
              <tr
                v-for="(item, index) in this.evaluations"
                :key="index"
                class="row"
              >
                <td class="col-1">
                  <div class="form-group">
                    <div class="input-group">
                      <input
                        id="defaultCheck1"
                        v-model="item.isSelected"
                        type="checkbox"
                        :checked="item.isSelected"
                        :disabled="atCompletedFlag"
                        class="option-input checkbox"
                        @click="getSelectedEvaluations(item)"
                      />
                      <label for="defaultCheck1">
                        <span>
                          <i class="ic-check" />
                        </span>
                      </label>
                    </div>
                  </div>
                </td>
                <td class="col-2">
                  {{ item.disciplineName }}
                </td>
                <td class="col-3">
                  {{ formatDate(item.evaluationDate) }}
                </td>
                <td class="col-3">
                  {{ item.evaluationAdministeredBy }}
                </td>
                <td class="col-3">
                  <div class="action-container">
                    <div class="center-box">
                      <div class="dropdown">
                        <button
                          id="dropdownMenuButton"
                          class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                          type="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Acciones
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <div class="dropdown-item" @click="download(item)">
                            <i class="fas fa-file-download text-green" />
                            <span>Descargar</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr class="row">
                <td align="center" colspan="5" style="width: 100%;">
                  {{ this.resources['191306'] }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <span class="text-danger">
          {{
            validateEvaluations()
              ? ''
              : 'Favor de seleccionar la evaluación previa.'
          }}
        </span>
      </div>
    </div>

    <!-- fin Contenido -->
  </div>
</template>

<script>
import store from '@/store/index'; //Se debe coordinar si los components tendran acceso al store o no.
import resourcesService from '@/services/resources.js';
import moment from 'moment';

export default {
  name: 'RecentAtEvaliations',
  props: {
    requireEvaluation: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      evaluations: [],
      selectedIds: [],
      resources: [],
      ValidationTriggered: store.getters.getatValidationTriggered,
    };
  },
  methods: {
    getEvaluations() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(
            '/api/atservice/GetRecentEvaluations?peiId=' +
              store.getters.SelectedPei
          )
          .then((res) => {
            this.evaluations = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            this.response = err;
          });
      });
      return promise;
    },
    getSelectedEvaluations(item) {
      if (this.selectedIds.some((p) => p == item)) {
        this.selectedIds.splice(item, 1);
      } else {
        this.selectedIds.push(item);
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '191307',
      ]);
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    download(item) {
      if (item.recentEvaluationDocuments.length > 0) {
        this.$emit('download', item.recentEvaluationDocuments[0].attachmentId);
      }
    },
    validateEvaluations() {
      if (this.ValidationTriggered.validation) {
        return this.evaluations.some((x) => x.isSelected);
      } else {
        return true;
      }
    },
  },

  async mounted() {
    await this.getEvaluations();
    await this.loadResources();
  },
  computed: {
    atCompletedFlag() {
      return store.getters.getAtCompleted;
    },
  },
};
</script>
